import getGraphQlClient from '~graphql/getGraphQlClient';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import { ROOM_RESERVATIONS_BY_FUNERAL_SERVICE_ID } from '../queries/roomReservation';

export const fetchRoomReservationsByFuneralService = async (defuntoId) => {
  const graphQlClient = await getGraphQlClient();

  const where = {
    defunto_pointer: {
      have: {
        objectId: {
          equalTo: defuntoId,
        },
      },
    },
  };

  const response = await graphQlClient.query({
    variables: { where },
    query: ROOM_RESERVATIONS_BY_FUNERAL_SERVICE_ID,
    fetchPolicy: 'network-only',
  });

  return await unmarshalGraphqlResponse(response.data, 'room_reservations')
    .edges;
};
